export interface ICountry {
    name: string,
    value: string,
    flag: string,
}

const list = () => {
    const list: Array<ICountry> = [
        { name: "Bahrain", value: "BH", flag: "🇧🇭" },
        { name: "Saudi Arabia", value: "SA", flag: "🇸🇦" },
        { name: "United Arab Emirates", value: "AE", flag: "🇦🇪" },
        { name: "Kuwait", value: "KW", flag: "🇰🇼" },
        { name: "Oman", value: "OM", flag: "🇴🇲" },
        { name: "Qatar", value: "QA", flag: "🇶🇦" },
        { name: "Aruba", value: "AW", flag: "🇦🇼" },
        { name: "Afghanistan", value: "AF", flag: "🇦🇫" },
        { name: "Angola", value: "AO", flag: "🇦🇴" },
        { name: "Anguilla", value: "AI", flag: "🇦🇮" },
        { name: "Åland Islands", value: "AX", flag: "🇦🇽" },
        { name: "Albania", value: "AL", flag: "🇦🇱" },
        { name: "Andorra", value: "AD", flag: "🇦🇩" },
        { name: "Argentina", value: "AR", flag: "🇦🇷" },
        { name: "Armenia", value: "AM", flag: "🇦🇲" },
        { name: "American Samoa", value: "AS", flag: "🇦🇸" },
        { name: "Antarctica", value: "AQ", flag: "🇦🇶" },
        { name: "French Southern Territories", value: "TF", flag: "🇹🇫" },
        { name: "Antigua and Barbuda", value: "AG", flag: "🇦🇬" },
        { name: "Australia", value: "AU", flag: "🇦🇺" },
        { name: "Austria", value: "AT", flag: "🇦🇹" },
        { name: "Azerbaijan", value: "AZ", flag: "🇦🇿" },
        { name: "Burundi", value: "BI", flag: "🇧🇮" },
        { name: "Belgium", value: "BE", flag: "🇧🇪" },
        { name: "Benin", value: "BJ", flag: "🇧🇯" },
        { name: "Bonaire, Sint Eustatius and Saba", value: "BQ", flag: "🇧🇶" },
        { name: "Burkina Faso", value: "BF", flag: "🇧🇫" },
        { name: "Bangladesh", value: "BD", flag: "🇧🇩" },
        { name: "Bulgaria", value: "BG", flag: "🇧🇬" },
        { name: "Bahamas", value: "BS", flag: "🇧🇸" },
        { name: "Bosnia and Herzegovina", value: "BA", flag: "🇧🇦" },
        { name: "Saint Barthélemy", value: "BL", flag: "🇧🇱" },
        { name: "Belarus", value: "BY", flag: "🇧🇾" },
        { name: "Belize", value: "BZ", flag: "🇧🇿" },
        { name: "Bermuda", value: "BM", flag: "🇧🇲" },
        { name: "Bolivia, Plurinational State of", value: "BO", flag: "🇧🇴" },
        { name: "Brazil", value: "BR", flag: "🇧🇷" },
        { name: "Barbados", value: "BB", flag: "🇧🇧" },
        { name: "Brunei Darussalam", value: "BN", flag: "🇧🇳" },
        { name: "Bhutan", value: "BT", flag: "🇧🇹" },
        { name: "Bouvet Island", value: "BV", flag: "🇧🇻" },
        { name: "Botswana", value: "BW", flag: "🇧🇼" },
        { name: "Central African Republic", value: "CF", flag: "🇨🇫" },
        { name: "Canada", value: "CA", flag: "🇨🇦" },
        { name: "Cocos (Keeling) Islands", value: "CC", flag: "🇨🇨" },
        { name: "Switzerland", value: "CH", flag: "🇨🇭" },
        { name: "Chile", value: "CL", flag: "🇨🇱" },
        { name: "China", value: "CN", flag: "🇨🇳" },
        { name: "Côte d'Ivoire", value: "CI", flag: "🇨🇮" },
        { name: "Cameroon", value: "CM", flag: "🇨🇲" },
        { name: "Congo, The Democratic Republic of the", value: "CD", flag: "🇨🇩" },
        { name: "Congo", value: "CG", flag: "🇨🇬" },
        { name: "Cook Islands", value: "CK", flag: "🇨🇰" },
        { name: "Colombia", value: "CO", flag: "🇨🇴" },
        { name: "Comoros", value: "KM", flag: "🇰🇲" },
        { name: "Cabo Verde", value: "CV", flag: "🇨🇻" },
        { name: "Costa Rica", value: "CR", flag: "🇨🇷" },
        { name: "Cuba", value: "CU", flag: "🇨🇺" },
        { name: "Curaçao", value: "CW", flag: "🇨🇼" },
        { name: "Christmas Island", value: "CX", flag: "🇨🇽" },
        { name: "Cayman Islands", value: "KY", flag: "🇰🇾" },
        { name: "Cyprus", value: "CY", flag: "🇨🇾" },
        { name: "Czechia", value: "CZ", flag: "🇨🇿" },
        { name: "Germany", value: "DE", flag: "🇩🇪" },
        { name: "Djibouti", value: "DJ", flag: "🇩🇯" },
        { name: "Dominica", value: "DM", flag: "🇩🇲" },
        { name: "Denmark", value: "DK", flag: "🇩🇰" },
        { name: "Dominican Republic", value: "DO", flag: "🇩🇴" },
        { name: "Algeria", value: "DZ", flag: "🇩🇿" },
        { name: "Ecuador", value: "EC", flag: "🇪🇨" },
        { name: "Egypt", value: "EG", flag: "🇪🇬" },
        { name: "Eritrea", value: "ER", flag: "🇪🇷" },
        { name: "Western Sahara", value: "EH", flag: "🇪🇭" },
        { name: "Spain", value: "ES", flag: "🇪🇸" },
        { name: "Estonia", value: "EE", flag: "🇪🇪" },
        { name: "Ethiopia", value: "ET", flag: "🇪🇹" },
        { name: "Finland", value: "FI", flag: "🇫🇮" },
        { name: "Fiji", value: "FJ", flag: "🇫🇯" },
        { name: "Falkland Islands (Malvinas)", value: "FK", flag: "🇫🇰" },
        { name: "France", value: "FR", flag: "🇫🇷" },
        { name: "Faroe Islands", value: "FO", flag: "🇫🇴" },
        { name: "Micronesia, Federated States of", value: "FM", flag: "🇫🇲" },
        { name: "Gabon", value: "GA", flag: "🇬🇦" },
        { name: "United Kingdom", value: "GB", flag: "🇬🇧" },
        { name: "Georgia", value: "GE", flag: "🇬🇪" },
        { name: "Guernsey", value: "GG", flag: "🇬🇬" },
        { name: "Ghana", value: "GH", flag: "🇬🇭" },
        { name: "Gibraltar", value: "GI", flag: "🇬🇮" },
        { name: "Guinea", value: "GN", flag: "🇬🇳" },
        { name: "Guadeloupe", value: "GP", flag: "🇬🇵" },
        { name: "Gambia", value: "GM", flag: "🇬🇲" },
        { name: "Guinea-Bissau", value: "GW", flag: "🇬🇼" },
        { name: "Equatorial Guinea", value: "GQ", flag: "🇬🇶" },
        { name: "Greece", value: "GR", flag: "🇬🇷" },
        { name: "Grenada", value: "GD", flag: "🇬🇩" },
        { name: "Greenland", value: "GL", flag: "🇬🇱" },
        { name: "Guatemala", value: "GT", flag: "🇬🇹" },
        { name: "French Guiana", value: "GF", flag: "🇬🇫" },
        { name: "Guam", value: "GU", flag: "🇬🇺" },
        { name: "Guyana", value: "GY", flag: "🇬🇾" },
        { name: "Hong Kong", value: "HK", flag: "🇭🇰" },
        { name: "Heard Island and McDonald Islands", value: "HM", flag: "🇭🇲" },
        { name: "Honduras", value: "HN", flag: "🇭🇳" },
        { name: "Croatia", value: "HR", flag: "🇭🇷" },
        { name: "Haiti", value: "HT", flag: "🇭🇹" },
        { name: "Hungary", value: "HU", flag: "🇭🇺" },
        { name: "Indonesia", value: "ID", flag: "🇮🇩" },
        { name: "Isle of Man", value: "IM", flag: "🇮🇲" },
        { name: "India", value: "IN", flag: "🇮🇳" },
        { name: "British Indian Ocean Territory", value: "IO", flag: "🇮🇴" },
        { name: "Ireland", value: "IE", flag: "🇮🇪" },
        { name: "Iran, Islamic Republic of", value: "IR", flag: "🇮🇷" },
        { name: "Iraq", value: "IQ", flag: "🇮🇶" },
        { name: "Iceland", value: "IS", flag: "🇮🇸" },
        { name: "Israel", value: "IL", flag: "🇮🇱" },
        { name: "Italy", value: "IT", flag: "🇮🇹" },
        { name: "Jamaica", value: "JM", flag: "🇯🇲" },
        { name: "Jersey", value: "JE", flag: "🇯🇪" },
        { name: "Jordan", value: "JO", flag: "🇯🇴" },
        { name: "Japan", value: "JP", flag: "🇯🇵" },
        { name: "Kazakhstan", value: "KZ", flag: "🇰🇿" },
        { name: "Kenya", value: "KE", flag: "🇰🇪" },
        { name: "Kyrgyzstan", value: "KG", flag: "🇰🇬" },
        { name: "Cambodia", value: "KH", flag: "🇰🇭" },
        { name: "Kiribati", value: "KI", flag: "🇰🇮" },
        { name: "Saint Kitts and Nevis", value: "KN", flag: "🇰🇳" },
        { name: "Korea, Republic of", value: "KR", flag: "🇰🇷" },
        { name: "Lao People's Democratic Republic", value: "LA", flag: "🇱🇦" },
        { name: "Lebanon", value: "LB", flag: "🇱🇧" },
        { name: "Liberia", value: "LR", flag: "🇱🇷" },
        { name: "Libya", value: "LY", flag: "🇱🇾" },
        { name: "Saint Lucia", value: "LC", flag: "🇱🇨" },
        { name: "Liechtenstein", value: "LI", flag: "🇱🇮" },
        { name: "Sri Lanka", value: "LK", flag: "🇱🇰" },
        { name: "Lesotho", value: "LS", flag: "🇱🇸" },
        { name: "Lithuania", value: "LT", flag: "🇱🇹" },
        { name: "Luxembourg", value: "LU", flag: "🇱🇺" },
        { name: "Latvia", value: "LV", flag: "🇱🇻" },
        { name: "Macao", value: "MO", flag: "🇲🇴" },
        { name: "Saint Martin (French part)", value: "MF", flag: "🇲🇫" },
        { name: "Morocco", value: "MA", flag: "🇲🇦" },
        { name: "Monaco", value: "MC", flag: "🇲🇨" },
        { name: "Moldova, Republic of", value: "MD", flag: "🇲🇩" },
        { name: "Madagascar", value: "MG", flag: "🇲🇬" },
        { name: "Maldives", value: "MV", flag: "🇲🇻" },
        { name: "Mexico", value: "MX", flag: "🇲🇽" },
        { name: "Marshall Islands", value: "MH", flag: "🇲🇭" },
        { name: "North Macedonia", value: "MK", flag: "🇲🇰" },
        { name: "Mali", value: "ML", flag: "🇲🇱" },
        { name: "Malta", value: "MT", flag: "🇲🇹" },
        { name: "Myanmar", value: "MM", flag: "🇲🇲" },
        { name: "Montenegro", value: "ME", flag: "🇲🇪" },
        { name: "Mongolia", value: "MN", flag: "🇲🇳" },
        { name: "Northern Mariana Islands", value: "MP", flag: "🇲🇵" },
        { name: "Mozambique", value: "MZ", flag: "🇲🇿" },
        { name: "Mauritania", value: "MR", flag: "🇲🇷" },
        { name: "Montserrat", value: "MS", flag: "🇲🇸" },
        { name: "Martinique", value: "MQ", flag: "🇲🇶" },
        { name: "Mauritius", value: "MU", flag: "🇲🇺" },
        { name: "Malawi", value: "MW", flag: "🇲🇼" },
        { name: "Malaysia", value: "MY", flag: "🇲🇾" },
        { name: "Mayotte", value: "YT", flag: "🇾🇹" },
        { name: "Namibia", value: "NA", flag: "🇳🇦" },
        { name: "New Caledonia", value: "NC", flag: "🇳🇨" },
        { name: "Niger", value: "NE", flag: "🇳🇪" },
        { name: "Norfolk Island", value: "NF", flag: "🇳🇫" },
        { name: "Nigeria", value: "NG", flag: "🇳🇬" },
        { name: "Nicaragua", value: "NI", flag: "🇳🇮" },
        { name: "Niue", value: "NU", flag: "🇳🇺" },
        { name: "Netherlands", value: "NL", flag: "🇳🇱" },
        { name: "Norway", value: "NO", flag: "🇳🇴" },
        { name: "Nepal", value: "NP", flag: "🇳🇵" },
        { name: "Nauru", value: "NR", flag: "🇳🇷" },
        { name: "New Zealand", value: "NZ", flag: "🇳🇿" },
        { name: "Pakistan", value: "PK", flag: "🇵🇰" },
        { name: "Panama", value: "PA", flag: "🇵🇦" },
        { name: "Pitcairn", value: "PN", flag: "🇵🇳" },
        { name: "Peru", value: "PE", flag: "🇵🇪" },
        { name: "Philippines", value: "PH", flag: "🇵🇭" },
        { name: "Palau", value: "PW", flag: "🇵🇼" },
        { name: "Papua New Guinea", value: "PG", flag: "🇵🇬" },
        { name: "Poland", value: "PL", flag: "🇵🇱" },
        { name: "Puerto Rico", value: "PR", flag: "🇵🇷" },
        { name: "Korea, Democratic People's Republic of", value: "KP", flag: "🇰🇵" },
        { name: "Portugal", value: "PT", flag: "🇵🇹" },
        { name: "Paraguay", value: "PY", flag: "🇵🇾" },
        { name: "Palestine, State of", value: "PS", flag: "🇵🇸" },
        { name: "French Polynesia", value: "PF", flag: "🇵🇫" },
        { name: "Réunion", value: "RE", flag: "🇷🇪" },
        { name: "Romania", value: "RO", flag: "🇷🇴" },
        { name: "Russian Federation", value: "RU", flag: "🇷🇺" },
        { name: "Rwanda", value: "RW", flag: "🇷🇼" },
        { name: "Sudan", value: "SD", flag: "🇸🇩" },
        { name: "Senegal", value: "SN", flag: "🇸🇳" },
        { name: "Singapore", value: "SG", flag: "🇸🇬" },
        { name: "South Georgia and the South Sandwich Islands", value: "GS", flag: "🇬🇸" },
        { name: "Saint Helena, Ascension and Tristan da Cunha", value: "SH", flag: "🇸🇭" },
        { name: "Svalbard and Jan Mayen", value: "SJ", flag: "🇸🇯" },
        { name: "Solomon Islands", value: "SB", flag: "🇸🇧" },
        { name: "Sierra Leone", value: "SL", flag: "🇸🇱" },
        { name: "El Salvador", value: "SV", flag: "🇸🇻" },
        { name: "San Marino", value: "SM", flag: "🇸🇲" },
        { name: "Somalia", value: "SO", flag: "🇸🇴" },
        { name: "Saint Pierre and Miquelon", value: "PM", flag: "🇵🇲" },
        { name: "Serbia", value: "RS", flag: "🇷🇸" },
        { name: "South Sudan", value: "SS", flag: "🇸🇸" },
        { name: "Sao Tome and Principe", value: "ST", flag: "🇸🇹" },
        { name: "Suriname", value: "SR", flag: "🇸🇷" },
        { name: "Slovakia", value: "SK", flag: "🇸🇰" },
        { name: "Slovenia", value: "SI", flag: "🇸🇮" },
        { name: "Sweden", value: "SE", flag: "🇸🇪" },
        { name: "Eswatini", value: "SZ", flag: "🇸🇿" },
        { name: "Sint Maarten (Dutch part)", value: "SX", flag: "🇸🇽" },
        { name: "Seychelles", value: "SC", flag: "🇸🇨" },
        { name: "Syrian Arab Republic", value: "SY", flag: "🇸🇾" },
        { name: "Turks and Caicos Islands", value: "TC", flag: "🇹🇨" },
        { name: "Chad", value: "TD", flag: "🇹🇩" },
        { name: "Togo", value: "TG", flag: "🇹🇬" },
        { name: "Thailand", value: "TH", flag: "🇹🇭" },
        { name: "Tajikistan", value: "TJ", flag: "🇹🇯" },
        { name: "Tokelau", value: "TK", flag: "🇹🇰" },
        { name: "Turkmenistan", value: "TM", flag: "🇹🇲" },
        { name: "Timor-Leste", value: "TL", flag: "🇹🇱" },
        { name: "Tonga", value: "TO", flag: "🇹🇴" },
        { name: "Trinidad and Tobago", value: "TT", flag: "🇹🇹" },
        { name: "Tunisia", value: "TN", flag: "🇹🇳" },
        { name: "Turkey", value: "TR", flag: "🇹🇷" },
        { name: "Tuvalu", value: "TV", flag: "🇹🇻" },
        { name: "Taiwan, Province of China", value: "TW", flag: "🇹🇼" },
        { name: "Tanzania, United Republic of", value: "TZ", flag: "🇹🇿" },
        { name: "Uganda", value: "UG", flag: "🇺🇬" },
        { name: "Ukraine", value: "UA", flag: "🇺🇦" },
        { name: "United States Minor Outlying Islands", value: "UM", flag: "🇺🇲" },
        { name: "Uruguay", value: "UY", flag: "🇺🇾" },
        { name: "United States", value: "US", flag: "🇺🇸" },
        { name: "Uzbekistan", value: "UZ", flag: "🇺🇿" },
        { name: "Holy See (Vatican City State)", value: "VA", flag: "🇻🇦" },
        { name: "Saint Vincent and the Grenadines", value: "VC", flag: "🇻🇨" },
        { name: "Venezuela, Bolivarian Republic of", value: "VE", flag: "🇻🇪" },
        { name: "Virgin Islands, British", value: "VG", flag: "🇻🇬" },
        { name: "Virgin Islands, U.S.", value: "VI", flag: "🇻🇮" },
        { name: "Viet Nam", value: "VN", flag: "🇻🇳" },
        { name: "Vanuatu", value: "VU", flag: "🇻🇺" },
        { name: "Wallis and Futuna", value: "WF", flag: "🇼🇫" },
        { name: "Samoa", value: "WS", flag: "🇼🇸" },
        { name: "Yemen", value: "YE", flag: "🇾🇪" },
        { name: "South Africa", value: "ZA", flag: "🇿🇦" },
        { name: "Zambia", value: "ZM", flag: "🇿🇲" },
        { name: "Zimbabwe", value: "ZW", flag: "🇿🇼" },
    ]
    return list
}

const returnCountryValueBaseByName = (name: string) => {
    const countriesList = list()    
    let value: string = ""

    countriesList.map((country) => {
        if (country.name === name){
            value = country.value
        }
    })

    return value
}

const returnCountryNameBaseByValue = (value: string) => {
    const countriesList = list()    
    let name: string = ""

    countriesList.map((country) => {
        if (country.value === value){
            name = country.name
        }
    })

    return name
}

const returnCountryBasedByValue = (value: string) => {
    const countriesList = list()    
    const findCountry = countriesList.find((country) => country.value === value)
    
    return findCountry ? findCountry : null
}

/**
 * Countries
 */
const Countries = {
    list,
    returnCountryValueBaseByName,
    returnCountryNameBaseByValue,
    returnCountryBasedByValue
}
export default Countries